import { defineStore } from "pinia";
import { http } from "@/extensions/http";
import API_ENDPOINTS from "@/config/API_ENDPOINTS.ts";
import i18n from "@/i18n";

export const useNewsStore = defineStore("news", {
  state: () => ({
    memory: {
      index: {
        en: [],
        fr: [],
      } as Record<locale, News[]>,
      show: {
        en: {},
        fr: {},
      } as Record<locale, Record<string, News | undefined>>,
    },
  }),
  actions: {
    async all() {
      const locale: locale = i18n.global.locale.value;

      if (this.memory.index[locale].length) return this.memory.index[locale];

      const { data } = await http.get<News[]>(API_ENDPOINTS.NEWS.INDEX);

      this.memory.index[locale] = data.reverse();

      return data;
    },
    async get(newsId: string | number) {
      const locale: locale = i18n.global.locale.value;

      if (this.memory.show[locale][newsId] !== undefined) {
        return this.memory.show[locale][newsId];
      }

      const { data } = await http.get<News>(
        API_ENDPOINTS.NEWS.SHOW.replace(":news", newsId.toString()),
      );

      this.memory.show[locale][newsId] = data;

      return data;
    },
  },
});
